import * as React from "react"
import { useRouter } from "next/router"
import clsx from "clsx"
import { HARISENIN_LOGO } from "@constants/const/pictures"
import { BsArrowLeft } from "react-icons/bs"
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai"
import { RiShoppingBasketLine, RiLockPasswordFill, RiLogoutCircleRLine } from "react-icons/ri"
import { FaRegUserCircle } from "react-icons/fa"
import { HiOutlineUserGroup } from "react-icons/hi"
import { BiLoaderCircle } from "react-icons/bi"
import { priceFormatter } from "@lib/functions"
import { TokenData } from "@interfaces/auth"
import AuthServices from "@lib/api/services/auth.services"
import { FlexBox } from "@components/wrapper"
import { BasicLink } from "@components/typography"
import { Avatar } from "@components/misc"
import Image from "next/image"

interface SidebarMenu {
  icon: JSX.Element
  title: string
  href: string
}

const sidebarMenus: SidebarMenu[] = [
  {
    icon: <FaRegUserCircle />,
    title: "Profil",
    href: "profil",
  },
  {
    icon: <RiShoppingBasketLine />,
    title: "Daftar Pembelian",
    href: "order",
  },
  {
    icon: <RiLockPasswordFill />,
    title: "Ubah Password",
    href: "password",
  },
  // {
  //   icon: <HiOutlineUserGroup />,
  //   title: "Referral Program",
  //   href: "referral",
  // },
  {
    icon: <BiLoaderCircle />,
    title: "Video Course",
    href: "progress",
  },
]

export default function DashboardHeaderMobile({ tokenData }: { tokenData: TokenData }) {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false)
  const auth = new AuthServices()
  const router = useRouter()

  function handleMenu() {
    setIsMenuOpen(!isMenuOpen)
  }

  async function logout() {
    await auth.logout()
    router.reload()
  }

  return (
    <>
      <FlexBox
        direction="row"
        justify="between"
        align="center"
        className="flex w-full py-5 px-4 bg-primary-grey sticky top-0 z-[10]"
      >
        {isMenuOpen ? (
          <BasicLink href="/" className="w-5">
            <BsArrowLeft className="text-xl" />
          </BasicLink>
        ) : (
          <div className="w-5"></div>
        )}
        <Image
          src={HARISENIN_LOGO}
          alt="harisenin.com logo"
          className="h-3.5"
          height={28}
          width={100}
        />
        <button onClick={handleMenu} className="w-5">
          {isMenuOpen ? (
            <AiOutlineClose className="text-xl " />
          ) : (
            <AiOutlineMenu className="text-xl" />
          )}
        </button>
      </FlexBox>
      <div
        className={clsx(
          "shadow-lg h-screen transition-all duration-700 ease-in-out bg-white top-[60px] fixed z-[10]",
          isMenuOpen ? "left-0" : "-left-full"
        )}
      >
        <FlexBox direction="col" className="w-screen px-4 py-8">
          <FlexBox direction="col" align="center">
            <Avatar
              className="rounded-full h-24 w-24"
              src={tokenData?.user_picture}
              alt="avatar user"
              size={96}
            />
            <div className=" text-secondary-black font-medium leading-6 mt-2">
              {tokenData?.fullname}
            </div>
          </FlexBox>
          <FlexBox direction="col" className="gap-2 mt-4 px-5">
            <hr className="border-none h-0.5 bg-grey-ec" />
            <FlexBox justify="between" className="text-base font-medium leading-6">
              <div className="text-grey-97">Saldo Aktif</div>
              <div className="text-grey-48">{priceFormatter(0)}</div>
            </FlexBox>
            <hr className="border-none h-0.5 bg-grey-ec" />
          </FlexBox>
          <FlexBox direction="col" className="mt-4 gap-3 max-h-[52vh] overflow-y-auto">
            {sidebarMenus.map((sidebarMenu, index) => (
              <SidebarMobileLink
                key={index}
                href={sidebarMenu.href}
                title={sidebarMenu.title}
                icon={sidebarMenu.icon}
              />
            ))}
            <FlexBox
              align="center"
              className="gap-4 font-md font-semibold bg-primary-grey text-red hover:cursor-pointer px-5 py-2.5"
              onClick={logout}
            >
              <RiLogoutCircleRLine className="text-xl" />
              <div className="leading-6">Keluar</div>
            </FlexBox>
            <BasicLink
              href="/"
              className="flex align-center gap-4 font-md font-medium bg-primary-grey text-grey-97 hover:text-green px-5 py-2.5"
            >
              <BsArrowLeft className="text-xl" />
              <div className="leading-6">Kembali ke halaman utama</div>
            </BasicLink>
          </FlexBox>
        </FlexBox>
      </div>
    </>
  )
}

const SidebarMobileLink = ({ icon, title, href }: SidebarMenu) => {
  const router = useRouter()
  if (!router.asPath.includes(href)) {
    return (
      <a href={`/dashboard/${href}`}>
        <FlexBox
          align="center"
          className="bg-primary-grey gap-4 font-md bg font-medium px-5 py-2.5 rounded-sm text-grey-97 hover:text-green"
        >
          <i className="text-xl">{icon}</i>
          <div className="leading-6">{title}</div>
        </FlexBox>
      </a>
    )
  } else {
    return (
      <FlexBox
        align="center"
        className="bg-primary-grey gap-4 font-md font-medium px-5 py-2.5 text-green"
      >
        <i className="text-xl">{icon}</i>
        <div className="leading-6">{title}</div>
      </FlexBox>
    )
  }
}
